import qs from 'qs';

export interface Gr8NavigationPayload {
  path?: string;
  query?: Record<string, unknown>;
}

const gr8BootstrapPathPrefixes = ['/events', '/promo', '/my-bets'];

export function normalizeGr8Path(path?: string) {
  const value = path?.trim();
  if (!value || value === '/') {
    return '/';
  }
  return value.startsWith('/') ? value : `/${value}`;
}

export function requiresGr8Bootstrap(path?: string) {
  const pathname = normalizeGr8Path(path).split('?')[0];
  return gr8BootstrapPathPrefixes.some(
    prefix => pathname === prefix || pathname.startsWith(`${prefix}/`),
  );
}

export function shouldHideSportsNavigation(path?: string) {
  const pathname = normalizeGr8Path(path).split('?')[0];
  return pathname.startsWith('/events') || pathname.startsWith('/my-bets');
}

export function getGr8Language(language?: string) {
  return language?.split('_')[0].toLowerCase() || 'en';
}

export function buildGr8Url({
  baseUrl,
  language,
  path,
  token,
}: {
  baseUrl: string;
  language?: string;
  path?: string;
  token?: string;
}) {
  const normalizedBaseUrl = baseUrl.endsWith('/') ? baseUrl : `${baseUrl}/`;
  const normalizedPath = normalizeGr8Path(path);
  const [pathname, query = ''] = normalizedPath.split('?');
  const queryParams = qs.parse(query);

  if (token) {
    queryParams.jwt = token;
  } else {
    delete queryParams.jwt;
  }

  const queryString = qs.stringify(queryParams);
  return `${normalizedBaseUrl}${getGr8Language(language)}${pathname}${
    queryString ? `?${queryString}` : ''
  }`;
}

export function getGr8NavigationPath(
  payload: Gr8NavigationPayload,
  language?: string,
) {
  const languagePrefix = getGr8Language(language);
  const path = normalizeGr8Path(payload.path).replace(
    new RegExp(`^/(?:en|${languagePrefix})(?=/|$)`),
    '',
  );
  const query = {...payload.query};
  delete query.jwt;
  const queryString = qs.stringify(query);

  return `${normalizeGr8Path(path)}${queryString ? `?${queryString}` : ''}`;
}
